<template>
  <svg width="17" height="33" viewBox="0 0 17 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 32L16 16.5L1.00001 0.999996" stroke="#3A913F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "ChevronRightIcon",
  props: {
    fill: {
      type: String,
      default: '#fff'
    }
  }
}
</script>
